<template>
  <div class="layout-container label-container">
    <el-tabs type="border-card">
      <el-tab-pane label="百科标签">
        <div style="background: #ffffff; position: relative">
          <div class="search-condition-con">
            <div class="search-condition">
              <span class="label">标签名称</span>
              <div class="input-condition">
                <el-input
                  v-model="condition.name"
                  placeholder="请输入标签"
                  maxlength="6"
                ></el-input>
              </div>
            </div>
            <el-button
              class="label-search-btn"
              type="primary"
              @click="handleSearch()"
              >查 询</el-button
            >
            <el-button class="label-search-btn" @click="resetSearch()"
              >清空条件</el-button
            >
          </div>
        </div>
        <div class="clearfix" style="margin-bottom: 5px">
          <el-button-group class="floatR">
            <el-button @click="showAddLabel" icon="el-icon-plus" v-permission="'operating.wikipedia.tag.list.create'"
              >新增标签</el-button
            >
          </el-button-group>
        </div>
        <div class="table-detail-list">
          <el-table
            :data="list"
            style="width: 100%"
            :highlight-current-row="true"
            stripe
            tooltip-effect="dark"
            ref="multipleTable"
            v-loading="isLoading"
            header-cell-class-name="table-back"
            @sort-change="changeSort"
          >
            <el-table-column label="标签名称" prop="name"></el-table-column>
            <el-table-column label="百科关联数" prop="rel_num"   sortable="custom"></el-table-column>
            <el-table-column
              label="百科最近关联时间"
              prop="last_rel_time"
            ></el-table-column>
            <el-table-column
              label="标签添加时间"
              prop="created_at"
            ></el-table-column>
            <el-table-column label="添加人" prop="creator"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  v-permission="'operating.wikipedia.tag.list.edit'"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  v-permission="'operating.wikipedia.tag.list.delete'"
                  @click="handleDelete(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <template v-if="list.length > 0">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :current-page="condition.page"
            :total="condition.total"
            :page-size="condition.per_page"
            @current-change="currentChange"
          ></el-pagination>
        </template>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="编辑标签"
      :visible.sync="editVisible"
      width="20%"
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-input v-model="editLabel"></el-input>
      <p v-if="showError" class="error-tip">{{ errorCnt }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
    <add-label ref="addLabel" :callback="initData"></add-label>

  </div>
</template>

<script>
import {
  getWikipediaLabels,
  editWikipediaLabel,
  deleteWikipediaLabel,
} from "@/service/wikipedia";
import AddLabel from './component/addLabel.vue';

export default {
  name: "baikeLabel",
  components: {AddLabel},
  data() {
    return {
      isLoading: false,
      editVisible: false,
      showError: false,
      tag_name: null,
      errorCnt: "",
      editLabel: "",
      editId:'',
      condition:{
        name: "",
        total: 0,
        per_page: 10,
        page: 1,
      },
      list: [],
    };
  },
  mounted() {
      this.initData()
  },
  methods: {
    changeSort(val){
      this.condition.sort_name='rel_num'
      if(val.order=="descending"){
        this.condition.sort_order='desc'
      }else{
        this.condition.sort_order='asc'
      }
      this.initData()
    },
      initData(){
        this.list=[]
        this.isLoading = true;
        getWikipediaLabels(this.condition).then(data => {
            if(data.data.length){
                this.condition.total=data.total
                this.list = data.data;
            }
        });

        this.isLoading = false;

    },
    handleSearch(){
      this.condition.page=1
      this.$refs.multipleTable.clearSort();
      this.initData()
    },
    resetSearch(){
      this.$refs.multipleTable.clearSort();
      this.condition.name=""
      this.condition.page=1
      this.initData();
    },
    showAddLabel(){
       this.$refs.addLabel &&this.$refs.addLabel.open();
    },

    handleEdit(index, row) {
      this.showError = false;
      this.editVisible = true;
      this.editLabel = row.name;
      this.editId=row.id
    },
    submitEdit() {
      this.showError = false;
      if (this.editLabel.length <= 0) {
        this.errorCnt = "标签不能为空";
        this.showError = true;
        return null;
      }
      if (this.editLabel.length > 6) {
        this.errorCnt = "'" + this.editLabel + "'超长，请修改";
        this.showError = true;
        return null;
      }
      if (this.showError) {
        return null;
      } else {
        editWikipediaLabel(this.editId,{'name':this.editLabel})
          .then((data) => {
            this.$message({
              message: "编辑成功",
              type: "success",
              duration: 3 * 1000,
            });
            this.reset();
            this.initData()
          })
          .catch((err) => {
            const message = err.message;
            this.$message({
              message: message || "编辑失败",
              type: "error",
              duration: 3 * 1000,
            });
          });
      }
    },
    handleClose() {
      this.reset();
    },
    reset() {
      this.errorCnt = null;
      this.showError = false;
      this.editVisible = false;
    },
    currentChange(index) {
      this.condition.page = index;
      this.initData();
    },
    handleDelete(id) {
      this.$confirm("删除后不可撤回，是否确认操作？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
      }).then(() => {
          deleteWikipediaLabel(id)
          .then(() => {
              this.$message({
              type: "success",
              message: "删除成功"
              });
              this.initData();
          })
          .catch(err => {
              this.$message({
              type: "error",
              message: err.message || "删除失败"
              });
          });
      });
    },
  },
};
</script>
<style>
.label-search-btn {
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
}
.el-dialog__body {
  padding: 10px 20px 10px !important;
}
.el-dialog__body p {
  line-height: 30px;
}
.error-tip {
  color: red;
}
</style>